export const kidsTable = () => {
    const kidsTables = document.querySelectorAll('.kids-table');
    const kidsTableSelect = document.querySelector('#kids-table-language');
    if (!kidsTables.length || !kidsTableSelect) return;

    // Collect all rows from all kids-table elements
    const kidsTableRows = [];
    kidsTables.forEach(table => {
        const rows = table.querySelectorAll('tbody tr');
        kidsTableRows.push(...rows);
    });

    kidsTableSelect.addEventListener('change', (e) => {
        let language = e.target.value;

        kidsTableRows.forEach(row => {
            const rowLanguage = row.getAttribute('data-language');
            if (language === rowLanguage) {
                row.classList.remove('is-hidden');
            } else {
                row.classList.add('is-hidden');
            }
        });
    });
}